import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Mail } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { F } from "./Fields";

export const AccountForm = () => (
  <div className="grid lg:grid-cols-2 gap-12">
    <PasswordForm />
    <EmailForm />
  </div>
);

const EmailForm = () => {
  const { user, setUser } = useAuth();
  const [v, setV] = useState({ email: "", password: "", fanPassword: "" });
  const [needFan, setNeedFan] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const payload = { current_password: v.password, new_email: v.email.trim() };
      if (needFan) payload.existing_password = v.fanPassword;
      const { data } = await api.post("/auth/change-email", payload);
      setUser(data);
      setV({ email: "", password: "", fanPassword: "" });
      setNeedFan(false);
      toast.success("Correo actualizado. Úsalo para entrar y recuperar tu contraseña.");
    } catch (err) {
      if (err?.response?.status === 409) setNeedFan(true);
      setError(errMsg(err));
    } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="grid gap-5 max-w-md content-start" data-testid="email-form">
      <p className="font-display text-3xl">Correo de la cuenta</p>
      <p className="text-sm text-[#A8B3C4]">Pon tu correo real: ahí te llegará el enlace si olvidas la contraseña. También será tu correo para entrar.</p>
      <F label="Nuevo correo" type="email" value={v.email} onChange={(e) => { setNeedFan(false); setV({ ...v, email: e.target.value }); }} required placeholder="tu-correo@gmail.com" autoComplete="off" name="new-account-email" data-testid="account-new-email" />
      <F label="Contraseña actual del panel" type="password" value={v.password} onChange={(e) => setV({ ...v, password: e.target.value })} required autoComplete="current-password" data-testid="account-email-password" />
      {needFan && (
        <F label="Contraseña de tu cuenta de fan con ese correo" type="password" value={v.fanPassword} onChange={(e) => setV({ ...v, fanPassword: e.target.value })} required autoComplete="off" data-testid="account-fan-password" />
      )}
      {error && <p className="text-sm text-[#FCA5A5]" data-testid="account-email-error">{error}</p>}
      <button data-testid="account-email-save" disabled={busy} className="flex items-center justify-center gap-2 px-6 py-3.5 border border-[#1FD1FF] text-[#1FD1FF] font-mono text-sm uppercase tracking-widest hover:bg-[#1FD1FF] hover:text-black transition-colors disabled:opacity-60">
        <Mail className="w-4 h-4" />{busy ? "Guardando…" : "Cambiar correo"}
      </button>
    </form>
  );
};

const PasswordForm = () => {
  const { user } = useAuth();
  const [v, setV] = useState({ current: "", next: "", repeat: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setError("");
    if (v.next.length < 8) return setError("La nueva contraseña debe tener al menos 8 caracteres.");
    if (v.next !== v.repeat) return setError("Las contraseñas nuevas no coinciden.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: v.current, new_password: v.next });
      setV({ current: "", next: "", repeat: "" });
      toast.success("Contraseña cambiada. Las demás sesiones abiertas se cerraron.");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="grid gap-5 max-w-md content-start" data-testid="account-form">
      <p className="font-display text-3xl">Contraseña</p>
      <p className="text-sm text-[#A8B3C4]">Cuenta: <span className="text-white">{user?.email}</span></p>
      <F label="Contraseña actual" type="password" value={v.current} onChange={set("current")} required autoComplete="current-password" data-testid="account-current-password" />
      <F label="Nueva contraseña (mínimo 8)" type="password" value={v.next} onChange={set("next")} required autoComplete="new-password" data-testid="account-new-password" />
      <F label="Repite la nueva contraseña" type="password" value={v.repeat} onChange={set("repeat")} required autoComplete="new-password" data-testid="account-repeat-password" />
      {error && <p className="text-sm text-[#FCA5A5]" data-testid="account-error">{error}</p>}
      <button data-testid="account-save-button" disabled={busy} className="flex items-center justify-center gap-2 px-6 py-3.5 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest hover:bg-white transition-colors disabled:opacity-60">
        <KeyRound className="w-4 h-4" />{busy ? "Guardando…" : "Cambiar contraseña"}
      </button>
    </form>
  );
};
